import type { SectionsBoardProfilesComponent } from '@twisto/api-cms'

import { StrapiMedia } from '../../atoms'

import * as styles from './board-profiles.styles'

export const BoardProfileInfo = ({
  title,
  subtitle,
  profiles,
}: SectionsBoardProfilesComponent) => (
  <div css={styles.wrap}>
    <div css={styles.subtitle}>{subtitle}</div>
    <div css={styles.title}>{title}</div>

    {profiles && (
      <ul css={styles.list}>
        {profiles.map((profile) => (
          <li key={profile.id} css={styles.profile}>
            <StrapiMedia {...profile.src} css={styles.photo} />

            <div css={styles.info}>
              <div css={styles.position}>{profile.navigationText}</div>
              <div css={styles.name}>{profile.title}</div>
              <div css={styles.desc}>{profile.description}</div>
            </div>
          </li>
        ))}
      </ul>
    )}
  </div>
)
